import {InitSlider} from "./slider";
const productRecommendationsSection = document.querySelector('.js-product-recommendations');

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.js-product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }

        })
        .catch(e => {
            console.error(e);
        })
        .finally(() => {
            const slider = productRecommendationsSection.querySelector('.js-slider');
            InitSlider(slider);
        });
};


const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

if(productRecommendationsSection) {
    observer.observe(productRecommendationsSection);


    // document.addEventListener('click', event => {
    //     const $slider = event.target.closest('.js-product-recommendations');
    //
    //     if($slider) {
    //         const $prev = $slider.querySelector('.js-recently-slider-prev');
    //         const $next = $slider.querySelector('.js-recently-slider-next');
    //         const width = $slider.querySelector('.js-slider-track ').querySelector('div').clientWidth;
    //
    //         $prev.addEventListener('click', () => {
    //             $slider.querySelector('.js-slider-track').scrollLeft -= width;
    //         });
    //         $next.addEventListener('click', () => {
    //             $slider.querySelector('.js-slider-track').scrollLeft += width;
    //         });
    //     }
    // });

}
